<style scoped lang="scss">
@import "../../styles/var";
@import "../../styles/mixins";

.record-img-wrap {
  ul {
    li {
      padding-bottom: 20%;
      position: relative;
    }
  }

  img {
    position: absolute;
    max-width: 80%;
    max-height: 100%;
  }
}

.tip {
  background: #E6F1FC;
  border-radius: 12px;
  width: 80%;
  margin: 5px auto;
}

.record-item {
  //margin-top: 20px;
  //padding-left: 15px;
  //padding-right: 15px;
  font-size: 14px;
  color: #cccccc;

  .record-item-title {
    font-weight: bold;
    color: #666666;
    margin-top: 5px;
    display: flex;
    align-items: center;

    &:before {
      margin-right: 5px;
      content: '';
      width: 3px;
      height: 14px;
      background-color: $mainColor;
    }
  }

  .record-item-content {
    color: #666666;
  }

  .record-item-content {
    padding: 0 !important;
  }
}

ul {
  flex-wrap: wrap;

  li {
    width: 20%;
  }
}
</style>
<template>
  <div class="info flex column">
    <div v-if="showTag && !inRecipe" class="flex flex1 aic jcc pt100 pb100 column">
      <img src="../../assets/blank-default.png" alt="">
      <p class="pt15">请按序选择患者“接诊” 进行网络门诊</p>
    </div>
    <div class="flex1" v-else>
      <div v-if="inRecipe" class="record-item">
        <p class="record-item-title">患者信息：</p>
        <p class="record-item-content">
          {{ info.compatName }} {{ info._sex || info.compatGender }} {{ info.compatAge }}
          联系电话：{{ info.commpatMobile || info.compatMobile || info.consulterMobile }}<br/>
          <span v-if="info.compatHosCardId">就诊卡号：{{ info.compatHosCardId }}</span>
        </p>
      </div>
      <div v-else class="flex pl15 pr15 fs18 pt10 pb10 bb">
        <h3 class="flex1">
          {{ ddxx.patname }}
          {{ ddxx.sex }}
          <span v-if="ddxx.age">{{ ddxx.age }}岁</span>
        </h3>
        <span class="flex0">就诊卡号：{{ ddxx.jzkh }}</span>
      </div>
      <div v-if="!inRecipe" class="tip fs12 flex jcc pt5 pb5 color_main">
        以下资料由患者提交，查看院内病历点击
        <span class="pointer ml5">HIS病历</span>
      </div>
      <div class="record-item">
        <div class="record-item-title">
          所患疾病
        </div>
        <div class="record-item-content">
          {{ info.presentingComplaint || '空' }}
        </div>
      </div>
      <div class="record-item">
        <div class="record-item-title">
          患者主诉
        </div>
        <div class="record-item-content">
          {{ info.diseaseDescription || '空' }}
        </div>
      </div>
      <div class="record-item">
        <div class="record-item-title">
          既往史
        </div>
        <div class="record-item-content">
          {{ info.pastHistory || '空' }}
        </div>
      </div>
      <div class="record-item">
        <div class="record-item-title">
          家族史
        </div>
        <div class="record-item-content">
          {{ info.familyHistory || '空' }}
        </div>
      </div>
      <div class="record-item">
        <div class="record-item-title">
          过敏史
        </div>
        <div class="record-item-content">
          {{ info.allergyHistory || '空' }}
        </div>
      </div>
      <div v-if="inRecipe" class="record-item">
        <div class="record-item-title">
          申请图片
        </div>
      </div>
      <div class="record-img-wrap pl15 pr15 pb15" :class="{'pt15': !inRecipe}">
        <ul class="flex">
          <li v-for="(img,index) in info.attaList" class="flex0 mb10">
            <img :src="img.attaFileUrl" alt="" class="pointer" @click="scan(index,info.attaList)">
          </li>
        </ul>
      </div>
      <div class="deal-msg color_999 fs12 pl15 pr15 pb15 flex">
        <span class="flex1"></span>
        <span class="flex0">{{ ddxx.hyrq }}</span>
        <span class="flex0 ml5">{{ ddxx.hysj }}</span>
      </div>
      <!--  TODO 临时修改状态为1，原状态为7    -->
      <div v-if="showControl && !inRecipe && ddxx.ddzt =='7'" class="btns flex0">
        <ul class="flex bt">
          <li v-for="(btn,index) in btns" :key="index" class="flex0 flex column aic jcc pt10 pb10"
              :class="{pointer:btn.blank===false}" @click="handler(btn)">
            <div>
              <img :src="btn.icon" alt="">
            </div>
            <div class="text fs14" v-show="btn.blank===false">{{ btn.name }}</div>
          </li>
        </ul>
      </div>

    </div>
    <pic-scan ref="scan"></pic-scan>
  </div>
</template>
<script>
import {isEmpty} from "../../lib/utils";
import {getAgeFromIdCardFilter, getSexFromIdCardFilter} from "../../lib/filters";
import PicScan from "../common/pic-scan";

export default {
  name: "online-pat-info",
  components: {PicScan},
  props: {
    info: Object,
    showControl: {
      type: Boolean,
      default: true
    },
    inRecipe: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      btns: []
    }
  },
  computed: {
    showTag() {
      return isEmpty(this.info);
    },
    ddxx() {
      const {ddxx = {}} = this.info;
      if (ddxx.code === '0') return ddxx.obj;
      return {};
    },
  },
  filters: {getAgeFromIdCardFilter, getSexFromIdCardFilter},
  mixins: [],
  created() {
    this.getBtns();
  },
  async mounted() {

  },
  methods: {
    scan(index, list) {
      this.$refs.scan.show(index, list.map(r => r.attaFileUrl))
    },
    handler(btn) {
      this.$emit('btn-click', btn.name, this.ddxx);
    },
    getBtns() {
      const map = this.getBtnMap();
      this.btns = [...map].map(r => {
        return {
          name: r[0],
          blank: r[1].blank || false,
          icon: r[1].icon,
          action: r[1].handler
        }
      });
    },
    getBtnMap() {
      return new Map([
        ['书写病历', {
          icon: require('../../assets/icon/online/HIS病历.png'), handler() {
          }
        }],
        ['分诊', {
          icon: require('../../assets/icon/online/分诊.png'), handler() {
          }
        }],
        ['开处方', {
          icon: require('../../assets/icon/online/开处方.png'), handler() {
          }
        }],
        ['开检查', {
          icon: require('../../assets/icon/online/开检查.png'), handler() {
          }
        }],
        ['开检验', {
          icon: require('../../assets/icon/online/开住院单.png'), handler() {
          }
        }],
        ['加号', {
          icon: require('../../assets/icon/online/加号.png'), handler() {
          }
        }],
        ['转诊', {
          icon: require('../../assets/icon/online/转诊.png'), handler() {
          }
        }],
        ['0', {
          blank: true
        }],
        ['1', {
          blank: true
        }],
        ['结束问诊', {
          icon: require('../../assets/icon/online/结束问诊.png'), handler() {
          }
        }],
      ])
    }
  }
}
</script>

